// extracted by mini-css-extract-plugin
export default {"app":"App_app__BHoYS","tabs":"App_tabs__MtOEy","tab":"App_tab__R9n01","tabOn":"App_tabOn__USEly","pane":"App_pane__Vv3ag"};